import CheckoutTicketsModal from './CheckoutTicketsModal';

export default CheckoutTicketsModal;
